import { ApiService } from "./AbstractApiService";
import { IPageModel } from "@/interfaces/iPageModel";
import { ISavedFilter } from "@/interfaces/iSavedFilter";

export class SavedFilterAPI extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: SavedFilterAPI | null;
  constructor() {
    super("static-data/savedFilter");
  }
  public async getSaveFilterList(
    viewName: string
  ): Promise<Array<ISavedFilter>> {
    return this.get(`${viewName}`).then((response) => response.data);
  }
  public async postSavedFilter(
    payload: Omit<ISavedFilter, "webId" | "updateDate" | "createdDate">
  ): Promise<IPageModel<ISavedFilter>> {
    return this.post("", payload).then((response) => response.data);
  }
  //
  public async deletePreSavedFilter(webId: number): Promise<ISavedFilter> {
    return this.delete(`${webId}`).then((response) => response.data);
  }
  public async putSavedFilter(
    payload: ISavedFilter
  ): Promise<IPageModel<ISavedFilter>> {
    return this.put(`${payload.webId}`, payload).then(
      (response) => response.data
    );
  }
}
